import type { TourDefinition } from '@renderer/hooks/useTour';

/**
 * Sprint 26 — Tour del wizard "Cerrar Día" (Sprint 23.2 + 24).
 * Sprint 48 — Paso 5 añadido: panel post-cierre Sprint 42 (variante "cerrado").
 */
export const tourCerrarDia: TourDefinition = {
  id: 'cerrar_dia',
  title: 'Cómo cerrar el día (paso a paso)',
  steps: [
    {
      element: '[data-tour="cd-header"]',
      popover: {
        title: '1. Cerrar Día — entrada única',
        description:
          'Este wizard agrupa las 3 acciones de fin de jornada (Propinas, Corte Caja, Cierre Inventario) en un solo flujo ordenado. Haces todo sin salir y sin olvidar ningún paso.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="cd-stepper"]',
      popover: {
        title: '2. Los 4 pasos en orden',
        description:
          '① Revisar el día · ② Repartir propinas · ③ Cortar caja · ④ Cerrar inventario. El orden importa: si repartes propinas DESPUÉS del corte, el efectivo esperado queda desfasado.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="cd-pasos"]',
      popover: {
        title: '3. Acordeón con páginas embebidas',
        description:
          'Cada paso es una sección expandible. Al abrirla, la página completa de esa acción aparece dentro. Completas cada uno sin navegar a otro lado. Un ✓ verde indica paso terminado; ⏭ indica que decidiste saltarlo.',
        side: 'top',
      },
    },
    {
      element: '[data-tour="cd-final"]',
      popover: {
        title: '4. El botón rojo de cierre',
        description:
          'Se activa solo cuando todos los pasos están ✓ o ⏭. Si tienes pedidos sin cobrar, el sistema te bloquea aquí hasta que los resuelvas (los ves listados justo arriba del botón).',
        side: 'top',
      },
    },
    {
      element: '[data-tour="cd-header"]',
      popover: {
        title: '5. Después de cerrar el día',
        description:
          'Una vez cerrado, el wizard muestra un panel con el resumen completo del día y tres opciones: "Ir al inicio", "Ver reporte" y "Revisar pasos" (por si necesitas consultar algo sin reabrir el día). La marca de cierre se conserva aunque revises los pasos.',
        side: 'bottom',
        align: 'start',
      },
    },
  ],
};
